import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import type { Customer } from '@order/graphql';

const FS_KEY = 'run_fs_for_user';
const FS_SCRIPT = `
window['_fs_debug'] = false;
window['_fs_host'] = 'fullstory.com';
window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
window['_fs_org'] = 'ASX0T';
window['_fs_namespace'] = 'FS';
(function (m, n, e, t, l, o, g, y) {
  if (e in m) {
    if (m.console && m.console.log) {
      m.console.log(
        'FullStory namespace conflict. Please set window["_fs_namespace"].'
      );
    }
    return;
  }
  g = m[e] = function (a, b, s) {
    g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
  };
  g.q = [];
  o = n.createElement(t);
  o.async = 1;
  o.crossOrigin = 'anonymous';
  o.src = 'https://' + _fs_script;
  y = n.getElementsByTagName(t)[0];
  y.parentNode.insertBefore(o, y);
  g.identify = function (i, v, s) {
    g(l, { uid: i }, s);
    if (v) g(l, v, s);
  };
  g.setUserVars = function (v, s) {
    g(l, v, s);
  };
  g.event = function (i, v, s) {
    g('event', { n: i, p: v }, s);
  };
  g.anonymize = function () {
    g.identify(!!0);
  };
  g.shutdown = function () {
    g('rec', !1);
  };
  g.restart = function () {
    g('rec', !0);
  };
  g.log = function (a, b) {
    g('log', [a, b]);
  };
  g.consent = function (a) {
    g('consent', !arguments.length || a);
  };
  g.identifyAccount = function (i, v) {
    o = 'account';
    v = v || {};
    v.acctId = i;
    g(o, v);
  };
  g.clearUserCookie = function () {};
  g.setVars = function (n, p) {
    g('setVars', [n, p]);
  };
  g._w = {};
  y = 'XMLHttpRequest';
  g._w[y] = m[y];
  y = 'fetch';
  g._w[y] = m[y];
  if (m[y])
    m[y] = function () {
      return g._w[y].apply(this, arguments);
    };
  g._v = '1.3.0';
})(window, document, window['_fs_namespace'], 'script', 'user');
`;

// https://help.fullstory.com/hc/en-us/articles/360020828273-Getting-Started-with-FullStory

export const init = async () => {
  if (Platform.OS !== 'web') return;

  const item = await AsyncStorage.getItem(FS_KEY);
  const expireDate = new Date(Date.now() + 3600 * 24 * 1000);
  const isExpired = item && new Date(JSON.parse(item).expiration) < new Date();

  if (!item || isExpired) {
    // Sampling logic to capture every other user's session
    const fs_value = Math.ceil(Math.random() * 100) <= 50;

    await AsyncStorage.setItem(
      FS_KEY,
      JSON.stringify({ val: fs_value, expiration: expireDate }),
    );
  }

  const runFSValue = await AsyncStorage.getItem(FS_KEY);
  const shouldRecordSession = runFSValue ? JSON.parse(runFSValue).val : true;

  if (shouldRecordSession) {
    if (document.head.innerHTML.includes('fullstory')) return;
    const fullstoryScript = document.createElement('script');

    fullstoryScript.append(document.createTextNode(FS_SCRIPT));
    document.head.append(fullstoryScript);
  }
};

export const syncCustomer = (customer: Partial<Customer>) => {
  if (Platform.OS !== 'web' || !window?.FS) return;

  const fullName = `${customer.firstName} ${customer.lastName}`;

  window.FS.identify(customer.id, {
    displayName: fullName,
    email: customer.email,
    isReplatforming: true,
  });
};

export const resetCustomer = () => {
  if (Platform.OS !== 'web' || !window?.FS) return;

  window.FS.anonymize();
};
